import React from 'react';
import './index.css';

interface Props {
    icon: string;
    height?: number;
    width?: number;
    disabled?: boolean;
    active?: boolean;
}

const SvgIcon: React.FC<Props> = (props) => {
    return (
        <div
            className={`svgIcon ${(props.active) ? "active" : ""}`}
            children={
                <img
                    className={`icon ${(props.disabled) ? "disabled" : ""}`}
                    alt={'icon'}
                    src={props.icon}
                    height={props.height || 30}
                    width={props.width || 30}
                />
            }
        />
    );
};

export default SvgIcon;